var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 40,
  viewBox: "0 0 38 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10833_2550)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.1667 9.96387V33.333L32.1619 33.5047C32.0754 35.2089 30.7093 36.5757 29.0051 36.6623L28.8334 36.6663H10.5001L10.3284 36.6623C8.62408 36.5758 7.25729 35.209 7.17082 33.5047L7.16675 33.333V6.66634C7.16675 4.88298 8.56721 3.42644 10.3284 3.33708L10.5001 3.33301H24.9475L32.1667 9.96387ZM10.5001 4.58301C9.34949 4.58301 8.41675 5.51575 8.41675 6.66634V33.333C8.41675 34.4836 9.34949 35.4163 10.5001 35.4163H28.8334C29.9839 35.4163 30.9167 34.4835 30.9167 33.333V11.2497H24.6667C24.2065 11.2497 23.8334 10.8766 23.8334 10.4163V4.58301H10.5001ZM24.6667 10.4163H30.8126L24.6667 4.77181V10.4163Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10833_2550"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(0.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export { ForwardRef as ReactComponent };